<template>
  <vs-popup
    fullscreen
    :active.sync="isVisible"
    :title="$t('newsletter.title')"
    class="newsletter-popup"
    @close="onClose">
    <Grid
      ref="grid"
      :service="service"
      route_name="newsletters"
      order_column="created_at"
      direction="desc"
      hide_actions="true">
      <template v-slot:filterZone >
        <div class="grid grid-cols-2 gap-2 pt-2">
          <div>
            <select-suggestion
              :key="groupNewsKey"
              column="name"
              model="GroupNews"
              v-model="selectedGroupNews"
              :label="$t('group_news.group')"
              :appendClearOption="true"
              placeholderText="Digite o nome do grupo"
              class="required"
              @clearSelection="clearSubgroupNews"
              @selected-model="clearSubgroupNews"
            />
          </div>
          <div>
            <select-suggestion
              :key="subgroupNewsKey"
              column="name"
              model="SubgroupNews"
              v-model="selectedSubgroupNews"
              :label="$t('subgroup_news.subgroup')"
              :appendClearOption="true"
              placeholderText="Digite o nome do subgrupo"
              class="required"
              :disabled="!enableSubgroupNews"
              :extraParamsFilters="{group_news_id: selectedGroupNews ? selectedGroupNews.id : null}"
            />
          </div>
        </div>
      </template>
      <template v-slot:gridThead>
        <vs-th key="checkbox" width="5%" disable-sort>
          <b-form-checkbox
            v-model="selectAllChecked"
            @input="handleSelectAllInput" />
        </vs-th>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="title" sort-key="title">{{ $t('newsletter.title') }}</vs-th>
        <vs-th key="group_news_name" sort-key="group_news_name">{{ $t('group_news.group') }}</vs-th>
        <vs-th key="subgroup_news_name" sort-key="subgroup_news_name">{{ $t('subgroup_news.subgroup') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('newsletter.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="checkbox">
            <b-form-checkbox
              v-model="selectedList"
              :value="tr"
              @change="toggleItemSelection(tr)" />
          </vs-td>
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="20%" key="title">
            <div> {{ tr.title }}</div>
          </vs-td>
          <vs-td width="20%" key="group_news_name">
            <div> {{ tr.group_news_name }}</div>
          </vs-td>
          <vs-td width="20%" key="subgroup_news_name">
            <div> {{ tr.subgroup_news_name }}</div>
          </vs-td>
          <vs-td width="15%" key="status">
            <div> {{ tr.status_fmt }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
    <div class="flex justify-end gap-2 mt-4">
      <b-button @click="onAddSelected"
        variant="primary"
        :disabled="selectedList.length === 0">
        ({{ selectedList.length }}) {{$t('action.add')}}
      </b-button>

      <b-button @click="onClose" variant="secondary">
        {{$t('action.cancel')}}
      </b-button>
    </div>
  </vs-popup>
</template>


<script>

import Ripple from 'vue-ripple-directive'
import {  BFormCheckbox, BButton } from 'bootstrap-vue'
import SelectSuggestion from '@/components/SelectSuggestion.vue'

import NewsletterService from '@/services/api/NewsletterService'


export default {
  name: 'NewsletterPopup',
  components: {
    Ripple,
    SelectSuggestion,
    BFormCheckbox,
    BButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      selectedList: [],
      selectAllChecked: false,
      service: null,
      selectedGroupNews: null,
      selectedSubgroupNews: null,
      groupNewsKey: 0,
      subgroupNewsKey: 0,

    }
  },
  watch: {
    groupNewsFilter(val) {
      if (val) {
        this.$refs.grid.handleFilter(this.groupNewsFilter, 'group_news_id')
      } else {
        this.$refs.grid.resetFilters()
        this.$refs.grid.fetchGridData(true)
      }
    },
    subgroupNewsFilter(val) {
      if (val) {
        this.$refs.grid.handleFilter(this.subgroupNewsFilter, 'subgroup_news_id')
      } else {
        this.$refs.grid.resetFilters()
        this.$refs.grid.fetchGridData(true)
      }
    },
    selectedList: {
      handler() {
        this.$nextTick(() => {
          this.updateSelectAllState()
        })
      },
      deep: true
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    enableSubgroupNews(){
      return this.selectedGroupNews !== null && this.selectedGroupNews.id !== null
    },
    groupNewsFilter() {
      return this.isEmpty(this.selectedGroupNews) ? '' : this.selectedGroupNews.id
    },
    subgroupNewsFilter() {
      return this.isEmpty(this.selectedSubgroupNews) ? '' : this.selectedSubgroupNews.id
    }
  },
  methods: {
    onClose() {
      this.isVisible = false
    },
    onAddSelected() {
      this.$emit('selected-items', this.selectedList)
      // Limpa a seleção após adicionar
      this.selectedList = []
      this.selectAllChecked = false
      this.isVisible = false
    },
    enableCloneByGroup(item){
      const groupId = _.get(item, 'subgroup.group.id')
      return groupId !== null && groupId !== undefined && groupId !== ''
    },
    enableCloneBySubgroup(item){
      const subgroupId = _.get(item, 'subgroup.id')
      return subgroupId !== null && subgroupId !== undefined && subgroupId !== ''
    },
    reloadGrid(){
      this.$refs.grid.fetchGridData()
    },
    clearSubgroupNews() {
      this.selectedSubgroupNews = null
      this.subgroupNewsKey++
    },
    isItemSelected(item) {
      // For b-form-checkbox with v-model, we need to check if the item object is in the array
      return this.selectedList.some(selected => selected.id === item.id)
    },
    toggleItemSelection(item) {
      // b-form-checkbox with v-model already handles the selection automatically
      // This method is kept for compatibility but the actual selection is handled by v-model
      console.log('Item toggled:', item, 'Selected list:', this.selectedList)
    },
    handleSelectAllInput(checked) {
      console.log('handleSelectAllInput called with:', checked)
      const currentData = this.$refs.grid && this.$refs.grid.model && this.$refs.grid.model.data ? this.$refs.grid.model.data : []
      console.log('Current grid data:', currentData)

      if (checked) {
        // Select all items
        this.selectedList = [...currentData]
        console.log('Selected all items:', this.selectedList)
      } else {
        // Deselect all items
        this.selectedList = []
        console.log('Deselected all items')
      }
    },
    updateSelectAllState() {
      const currentData = this.$refs.grid && this.$refs.grid.model && this.$refs.grid.model.data ? this.$refs.grid.model.data : []
      this.selectAllChecked = currentData.length > 0 &&
        currentData.every(item => this.isItemSelected(item))
    }
  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
  }
}
</script>

<style lang="scss" scoped>
.newsletter-container {
  padding: 1rem 0;
  width: 100%;
}

</style>
